import React from "react"
import {Form, Formik} from "formik"
import Button from "../../../components/Button/Button"
import {getAcceptableTypesOfIdentificationValidationSchema} from "../../../components/RiskSettings/AcceptableTypesOfIdentification/AcceptableTypesOfIdentificationUtils"
import {isEqualWith, noop} from "lodash"
import RiskSettingsEditMode from "../../../components/RiskSettings/RiskSettingsEditMode"
import {
	RiskSettingsFieldNames,
	RiskSettingsType,
	showProhibitedBusinessVerticalsAndCountries,
} from "../../../components/RiskSettings/RiskSettingsUtils"
import {isEqualAsSet} from "../../../utilities/set"

interface OrgRiskSettingsRulesEditModeProps {
	initialValues: RiskSettingsType
	defaultValue: RiskSettingsType
	onCancel: () => void
	onSave: () => void
	formRef: React.RefObject<any>
}

export default function OrgRiskSettingsRulesEditMode({
	initialValues,
	defaultValue,
	onCancel,
	onSave,
	formRef,
}: OrgRiskSettingsRulesEditModeProps) {
	return (
		<>
			<Formik
				initialValues={initialValues}
				validateOnChange
				validationSchema={getAcceptableTypesOfIdentificationValidationSchema(
					RiskSettingsFieldNames.AcceptableTypesOfIdentification
				)}
				onSubmit={noop}
				innerRef={formRef}
			>
				{({values, handleChange, setFieldValue, setFieldTouched, isValid}) => {
					const hasExceptions = showProhibitedBusinessVerticalsAndCountries
						? !isEqualWith(values, defaultValue, isEqualAsSet)
						: !isEqualWith(
								values[RiskSettingsFieldNames.AcceptableTypesOfIdentification],
								defaultValue[RiskSettingsFieldNames.AcceptableTypesOfIdentification],
								isEqualAsSet
						  )
					return (
						<Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
							<div className="mb-5 is-flex is-justify-content-space-between">
								<h1 className="has-text-weight-bold is-size-4 is-align-self-center">Edit Onboarding Rules</h1>
								<div>
									<Button
										type="button"
										className="mr-3 pl-5"
										theme="danger"
										variant="outline"
										prefixIcon="edit-Arrow"
										disabled={!hasExceptions}
										onClick={() => {
											Object.entries(defaultValue).forEach(([key, value]) => {
												setFieldValue(key, value)
												setFieldTouched(key, true, false)
											})
										}}
									>
										Reset to default
									</Button>
									<Button
										type="button"
										className="mr-3"
										theme="danger"
										variant="outline"
										prefixIcon="delete-close-x"
										onClick={onCancel}
									>
										<span>Cancel</span>
									</Button>
									<Button
										theme="success"
										type="button"
										size="normal"
										variant="outline"
										prefixIcon="approve-v-check-validation"
										onClick={onSave}
										disabled={!isValid}
									>
										<span>Save changes</span>
									</Button>
								</div>
							</div>
							<RiskSettingsEditMode
								value={values}
								defaultValue={defaultValue}
								handleChange={handleChange}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
							/>
						</Form>
					)
				}}
			</Formik>
		</>
	)
}
